require.register("app/seller/show/RestaurantsTab", function(exports, require, module){
  $0
  
});

